import { SET_FILTER_FIELD, SET_FILTER_VALUE, RESET_FILTER } from '../actions/types'

const INITIAL_STATE = {
  fieldFilter: '',
  valueFilter: ''
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_FILTER_FIELD:
      return { ...state, fieldFilter: action.payload }
    case SET_FILTER_VALUE:
      return { ...state, valueFilter: action.payload }
    case RESET_FILTER:
      return { ...state, ...INITIAL_STATE }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/filterReducer.js